import React from 'react';
import NFTButton from '../NFTButton';
import { ListFilterContainer, ListFooter, ListItemsContainer, ListItemsWrapper, ListLoader, NFTListContainer } from './styled';
import debounce from 'lodash/debounce';
import Loader from '../../../../components/Loader';
import CategoryList from '../../data/NFTCategoryList'
import NFTComboBox, { IComboBoxItem } from '../../components/NFTCombobox';
import useNFTCollectionList from '../../data/useNFTCollectionList';
import { NFTPerPage, NFTSortingList } from '../../data/NFTFilterOptions';
import { useActiveWeb3React } from '../../../../hooks';
import { ChainId } from '@yetiswap/sdk';
import { ISaleTokenList, SaleTokenList } from '../../data/SaleTokenList';
import Scrollbar from '../../components/Scrollbar';
import Empty from '../Empty';
import uniqBy from 'lodash/uniqBy';

interface NFTListProps {
    id?: string;
    skipItems?: number;
    hasMore?: boolean;
    loading?: boolean;
    onClickLoadMore?: () => void;
    filterChange?: (param: number | string | null, key: string) => void;
    customHeader?: React.ReactNode;
    filterDefaultKeys?: { [key: string]: string | null };
    noFilter?: boolean;
}

const NFTList = (props: React.PropsWithChildren<NFTListProps>) => {

    const nftCollections = useNFTCollectionList();
    const { chainId } = useActiveWeb3React()

    //@ts-ignore
    const isEmptyList = props.children == null || props.children == undefined || props.children.length == 0;

    const onScroll = debounce((position: any) => {

        const isBottom = position && (position.clientHeight + position.scrollTop >= position.scrollHeight - 400);
        if (isBottom && props.onClickLoadMore && props.skipItems != 0 && props.hasMore && !props.loading) {
            props.onClickLoadMore()
        }
    }, 200);

    const categoryFilterItems = React.useMemo(() => {
        return CategoryList.map((item, index) => {
            return {
                key: item.id.toString(),
                text: item.name,
            }
        })
    }, []);

    const collectionFilterItems = React.useMemo(() => {
        let items = nftCollections.map((item: any) => {
            return {
                key: item.tokenAddress.toString(),
                text: item.name,
            }
        });
        items.unshift({ key: 'ALL', text: 'All' });
        return items;
    }, [nftCollections]);

    const sortFilterItems = React.useMemo(() => {
        return NFTSortingList.map(i => ({ key: i.key, text: i.text }));
    }, []);

    const perPageFilterItems = React.useMemo(() => {
        return NFTPerPage.map(i => ({ key: i.value?.toString(), text: i.text }));
    }, []);

    const currencyList = React.useMemo(() => {
        let items = SaleTokenList.map((item: ISaleTokenList) => {
            return {
                key: item[chainId ? chainId : ChainId.BOBA],
                text: item.name,
                renderItem: () => {
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', width: 120 }}>
                            <img src={item.image} alt={item.name} width={16} height={16} style={{ marginRight: 5 }} />
                            <div>{item.name}</div>
                        </span>
                    )
                }
            } as IComboBoxItem
        });
        items.unshift({ key: 'ALL', text: 'All' });
        return items;
    }, [chainId]);

    const onCurrencyFilterChange = React.useCallback((item: any) => {
        props.filterChange?.(item.key, 'currency');
    }, []);

    const onSortFilterChange = React.useCallback((item: any) => {
        props.filterChange?.(item.key, 'sort');
    }, []);

    const onPerPageFilterChange = React.useCallback((item: any) => {
        props.filterChange?.(item.key, 'perPage');
    }, []);

    const onCollectionFilterChange = React.useCallback((item: any) => {
        props.filterChange?.(item.key, 'collection');
    }, []);

    const onCategoryFilterChange = React.useCallback((item: any) => {
        props.filterChange?.(item.key, 'category')
    }, []);

    const renderEmpty = () => {
        if (isEmptyList && !props.loading) {
            return (<Empty size='large' />)
        }
        return <></>
    }

    return (
        <NFTListContainer id={props.id + "_container"}>
            <Scrollbar onUpdate={onScroll}>
                {props.customHeader}
                {!props.noFilter &&
                    <ListFilterContainer>
                        <NFTComboBox
                            items={collectionFilterItems}
                            defaultKey={props?.filterDefaultKeys?.collection || 'ALL'}
                            onSelectedChange={onCollectionFilterChange}
                            textPrefix='Collection: '
                            allowSearch
                        />
                        <NFTComboBox
                            items={categoryFilterItems}
                            defaultKey={props.filterDefaultKeys?.category || "0"}
                            onSelectedChange={onCategoryFilterChange}
                            textPrefix='Category: '
                        />
                        <NFTComboBox
                            items={currencyList}
                            defaultKey={props?.filterDefaultKeys?.currency || "ALL"}
                            onSelectedChange={onCurrencyFilterChange}
                            textPrefix='Currency: '
                        />
                        <NFTComboBox
                            items={sortFilterItems}
                            defaultKey={props?.filterDefaultKeys?.sort || 'NewestItems'}
                            onSelectedChange={onSortFilterChange}
                            textPrefix='Sort: '
                        />
                        <NFTComboBox
                            items={perPageFilterItems}
                            defaultKey={props?.filterDefaultKeys?.perPage || '20'}
                            onSelectedChange={onPerPageFilterChange}
                            textPrefix='Per Page: '
                        />
                    </ListFilterContainer>
                }
                {/* <ListItemsWrapper> */}
                <ListItemsContainer id={props.id}>
                    {renderEmpty()}
                    {props.children}
                </ListItemsContainer>
                <ListFooter>
                    {!isEmptyList && props.skipItems == 0 && props.hasMore && !props.loading &&
                        <NFTButton style={{ flex: 'unset', width: 200 }} onClick={props.onClickLoadMore}>Load More</NFTButton>
                    }
                    {props.loading && <ListLoader><Loader size='50px' /></ListLoader>}
                </ListFooter>
                {/* </ListItemsWrapper> */}
            </Scrollbar>
        </NFTListContainer>
    )
}
export default NFTList;